import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';

const posDef: BnrGpPosModel[] = [];

// Gesetzliche Weiterbildungspflicht (Voraussetzung für Bonifikation)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225001,
		group: 'gwp',
		posText: 'Weiterbildung IDD',
		posDesc: 'Voraussetzung für die Bonifikation ist der Nachweis von 15 Weiterbildungsstunden im Geschäftsjahr',
		planKey: 'idd',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225002,
		group: 'gwp',
		posText: 'Weiterbildung Kapitalmarktwissen',
		posDesc: 'Nachweis von 4 Weiterbildungsstunden Kapitalmarktwissen für die Fonds-Positionen',
		planKey: 'weiterbildungfonds',
		einheit: Einheit.bew,
	}),
);

// Vertriebsschwerpunkte (außerhalb der Maximierung)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'vss',
		posText: 'Qualität in Beratung und Vertrieb',
		posDesc: 'LPV beurteilt die individuelle Zielerreichung anhand konkreter Kriterien',
		planKey: '',
		einheit: Einheit.quali,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225013,
		group: 'vss',
		posText: 'Leben Neustück',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Leben Neustück im Geschäftsplan',
		planKey: 'lebnstmaz',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225021,
		group: 'vss',
		posText: 'Leben Einmalbeitrag',
		posDesc: 'Anzahl GV/HV mit mindestens 2.500 Bewertung ohne ZE',
		planKey: 'lebenknpebdigi',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225031,
		boniStufen: 2,
		group: 'vss',
		posText: 'Nettomittelzufluss',
		posDesc: 'Individuelles Arbeitsgebietsziel',
		planKey: 'fondsnettomittelzufluss',
		einheit: Einheit.bew,
	}),
);

// Eingangshürde
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225042,
		group: 'eh',
		posText: 'Leben',
		posDesc: 'Summe der Zielerfüllungen im individuellen Arbeitsgebiet - Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice',
		planKey: 'vaglebenbewdigi',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225043,
		group: 'eh',
		posText: 'Fonds inklusive FRV-Zusatzbewertung',
		posDesc: 'Bewertung - mindestens 90%',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225044,
		group: 'eh',
		posText: 'Fonds inklusive FRV-Zusatzbewertung',
		posDesc: 'Bewertung - Alternative zur Leben-Eingangshürde',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225013,
		group: 'eh',
		posText: 'Leben Neustück',
		posDesc: 'Anzahl GV/HV mit Erfüllung der Position VSP Leben Neustück im Geschäftsplan - Alternative zur Leben-Eingangshürde',
		planKey: 'lebnstmaz',
		einheit: Einheit.bew,
	}),
);

// Nach Eingangshürde (innerhalb einer Maximierung von 8.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225101,
		group: 'neh',
		posText: 'Leben',
		posDesc: 'Bewertung ohne ZE mit 1,5-facher Wertung PrivateFinance-/PrivateMarketsPolice',
		planKey: 'vaglebenbewdigi',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225111,
		group: 'neh',
		posText: 'Leben Risiko',
		posDesc: 'Bewertung ohne ZE',
		planKey: 'risikiolvbaufi',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225121,
		group: 'neh',
		posText: 'Leben Firmen',
		posDesc: 'Anzahl GV/HV mit mindestens 40.000 (20.000 VG NO) Bewertung ohne ZE',
		planKey: 'lfirmenknp80ris',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225131,
		group: 'neh',
		posText: 'Leben Firmen über FirmenOnline',
		posDesc: 'Bewertung ohne ZE',
		planKey: 'krankenbkVbew',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2225141,
		group: 'neh',
		posText: 'Fonds',
		posDesc: 'Bewertung',
		planKey: 'fondsbew',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);

// GeschäftsplanPlus (ohne Eingangshürde und innerhalb einer Maximierung von 3.000 EUR)
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3825021,
		group: 'gpplus',
		posText: 'Wiederanlage',
		posDesc: 'Wiederanlagesumme',
		planKey: 'wiederanlagesumme',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3825031,
		group: 'gpplus',
		posText: 'Fonds Firmen',
		posDesc: 'Bewertung',
		planKey: '',
		einheit: Einheit.bew,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 3825400,
		group: 'gpplus',
		posText: 'Teamausschreibung',
		posDesc: 'Platzierung in den Positionen im GSW der Vertriebsdirektion',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'gpplus',
		posText: '',
		posDesc: 'Kundenzuwachs',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'gpplus',
		posText: '',
		posDesc: 'Cross-Selling',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);
posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'gpplus',
		posText: '',
		posDesc: 'Meine Allianz',
		planKey: '',
		einheit: Einheit.nogoal,
	}),
);

export const VasPositionen = posDef;
